export const TOGGLE_MODAL = 'TOGGLE_MODAL'
export const SELECT_TABLE_ITEM = 'SELECT_TABLE_ITEM'
export const TRACKED_BUSINESSES = 'TRACKED_BUSINESSES'
export const REMOVE_TRACKED_BUSINESS = 'REMOVE_TRACKED_BUSINESS'
export const SAVE_BUSINESS_DATA = 'SAVE_BUSINESS_DATA';
export const SET_COUNTRIES = 'SET_COUNTRIES';
export const COMMISSION_CONFIG = 'COMMISSION_CONFIG';
export const REFRESHER = 'REFRESHER'